// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","copyright":"Footer_copyright__2OWH4","reactIcon":"Footer_reactIcon__3zFuR"};